export default __webpack_public_path__ + "static/media/EE86A4nU4AI53sv.ea474a17.jpg";